import Vue from 'vue'
import { abilitiesPlugin, Can } from '@casl/vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import axios from 'axios'
import VueCompositionAPI from '@vue/composition-api'
import VueMask from 'v-mask'
import VueSweetalert2 from 'vue-sweetalert2'

import ability from './libs/acl/ability'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'

// Sweet Alert
Vue.use(VueSweetalert2)

// Mask
Vue.use(VueMask)

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

Vue.use(abilitiesPlugin, ability)
Vue.component('Can', Can)

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  axios,
  render: h => h(App),
}).$mount('#app')
